import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCloseAccount = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M13.667 32c0-8.642 0-12.963 2.685-15.648S23.358 13.667 32 13.667s12.964 0 15.648 2.685c2.685 2.685 2.685 7.006 2.685 15.648s0 12.964-2.684 15.648c-2.685 2.685-7.007 2.685-15.649 2.685s-12.963 0-15.648-2.684S13.667 40.642 13.667 32"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.958 32c0-4.36-.003-7.492-.324-9.876-.315-2.343-.914-3.755-1.958-4.8s-2.457-1.643-4.8-1.958c-2.384-.32-5.516-.324-9.876-.324s-7.492.003-9.876.324c-2.343.315-3.755.914-4.8 1.959s-1.643 2.456-1.958 4.8c-.32 2.383-.324 5.515-.324 9.875s.003 7.492.324 9.876c.315 2.343.914 3.756 1.959 4.8s2.456 1.643 4.8 1.958c2.383.32 5.515.324 9.875.324s7.492-.003 9.876-.324c2.343-.315 3.756-.914 4.8-1.958s1.643-2.457 1.958-4.8c.32-2.384.324-5.516.324-9.876m2.75 0c0 4.282.004 7.632-.347 10.241-.356 2.649-1.1 4.739-2.741 6.379-1.64 1.64-3.73 2.385-6.379 2.741-2.61.35-5.959.347-10.24.347-4.283 0-7.633.004-10.242-.347-2.649-.356-4.738-1.1-6.379-2.741-1.64-1.64-2.385-3.73-2.74-6.379-.352-2.61-.348-5.959-.348-10.24 0-4.283-.004-7.633.347-10.242.356-2.649 1.1-4.738 2.741-6.379 1.64-1.64 3.73-2.385 6.38-2.74 2.608-.352 5.958-.348 10.24-.348s7.632-.004 10.241.347c2.649.356 4.739 1.1 6.379 2.741 1.64 1.64 2.385 3.73 2.741 6.38.35 2.608.347 5.958.347 10.24"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M32 32.458c2.355 0 4.535.783 6.318 2.104a1.375 1.375 0 0 1-1.636 2.21A7.82 7.82 0 0 0 32 35.207a7.82 7.82 0 0 0-4.682 1.563 1.375 1.375 0 0 1-1.636-2.209A10.57 10.57 0 0 1 32 32.458M37.5 30.167a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667M26.5 30.167a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667"
      />
    </svg>
  );
};
export default SvgCloseAccount;
